import { Platform } from 'quasar'
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin'
import { StatusBar, Style } from '@capacitor/status-bar'
import { Keyboard, KeyboardResize } from '@capacitor/keyboard'
import { CapacitorSquare } from '@zuc0001/capacitor-square'
import { App } from '@capacitor/app'
import Bus from 'src/helpers/bus'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import Dialog from 'src/helpers/dialog'

// leave the export, even if you don't use it
export default async ({ app }) => {
  if (!Platform.is.capacitor) {
    return
  }

  let hasPromptedIsDownloading = false
  let hasPromptedInstalling = false

  await CapacitorUpdater.addListener('download', async ({ bundle }) => {
    if (hasPromptedIsDownloading) {
      return
    }

    hasPromptedIsDownloading = true
    Dialog({
      title: 'Update downloading',
      message: `A new version is available. Version ${bundle.version} will now download in the background.`,
      persistent: true
    })
  })

  await CapacitorUpdater.addListener('updateAvailable', async ({ bundle }) => {
    if (hasPromptedInstalling) {
      return
    }

    hasPromptedInstalling = true
    try {
      Dialog({
        title: 'Update ready to install',
        message: `Version ${bundle.version} has downloaded and will now automatically install.`,
        persistent: true
      })
        .onDismiss(() => {
          CapacitorUpdater.set(bundle)
        })
    }
    catch (error) {
      console.error(error)
    }
  })

  await CapacitorUpdater.notifyAppReady()

  // #### not necessary for now
  // If not production, attempt to change to "test-X" channel
  // Production will use default channels set in Capgo
  // if (process.env.NODE_ENV !== 'production') {
  //   CapacitorUpdater.setChannel({
  //     channel: generateChannelStr(),
  //     triggerAutoUpdate: true
  //   })
  // }

  app.config.globalProperties.$nativeSecureStorage = SecureStoragePlugin

  StatusBar.setBackgroundColor({ color: '#000000' })
  // iOS Only
  StatusBar.setStyle({ style: Style.Default })
  // Android Only
  StatusBar.setOverlaysWebView({ overlay: false })

  // iOS Only
  Keyboard.setResizeMode({
    mode: KeyboardResize.Native
  })

  // The keyboard shrinks the webview, which lifts sticky dialog footers up over
  // the focused input. Flag the body while the keyboard is open so those footers
  // can hide and free the space (see .keyboard-visible rules in app.scss).
  Keyboard.addListener('keyboardWillShow', () => {
    document.body.classList.add('keyboard-visible')
  })
  Keyboard.addListener('keyboardWillHide', () => {
    document.body.classList.remove('keyboard-visible')
  })

  CapacitorSquare.initApp({
    applicationId: process.env.SQUARE_KEY
  }).catch(error => {
    console.error(error)
  })

  App.addListener('appUrlOpen', (data) => {
    if (data.url.toLowerCase().startsWith('miraapp://square-callback')) {
      Bus.emit('square:callback', data)
    }
  })

  // Listen for completed payments
  CapacitorSquare.addListener('transactionComplete', callback => {
    Bus.emit('square:callback', callback)
  })

  // Listen for failed payments
  CapacitorSquare.addListener('transactionFailed', callback => {
    Bus.emit('square:callback', callback)
  })
}

// Capgo channel string will be in format:
// prod-ios, prod-android, test-ios, test-android
// function generateChannelStr () {
//   const channel = process.env.NODE_ENV === 'production' ? 'prod' : 'test'
//   const platform = Platform.is.ios ? 'ios' : (Platform.is.android ? 'android' : 'unknown')
//
//   return `${channel}-${platform}`
// }
